(function () {
  'use strict';

  function init(root) {
    if (!root || root.dataset.wtgReady === 'true') return;
    root.dataset.wtgReady = 'true';
  }

  function initAll() {
    document.querySelectorAll('[data-why-tapo-grid]').forEach(init);
  }

  document.addEventListener('DOMContentLoaded', initAll);

  document.addEventListener('shopify:section:load', function (event) {
    var root = event.target && event.target.querySelector('[data-why-tapo-grid]');
    if (root) init(root);
  });
})();
